module.exports = "/fonts/vendor/socicon/socicon.ttf?9a64ef938f9e55a70a4defc6ac9790bf";